// Convert Array to Object
export const arrayToObjKeyValue = (array) => array && array.reduce( (obj,item) => {
    obj[item.name] = item.value;
    return obj;
},{});

export const LangArrayToObjKeyValue = (array) => array && array.reduce( (obj,item) => {
    obj[item.lang] = item.text;
    return obj;
},{});

export const getLangText = (langArray, currentLangId) => {
    if (!langArray || !Array.isArray(langArray) || langArray.length === 0) {
        return '';
    }

    const langObj = LangArrayToObjKeyValue(langArray);

    if (langObj[currentLangId]) {
        return langObj[currentLangId];
    }

    if (langObj['en']) {
        return langObj['en'];
    }

    if (langObj['ar']) {
        return langObj['ar'];
    }

    const availableKeys = Object.keys(langObj);
    if (availableKeys.length > 0) {
        return langObj[availableKeys[0]];
    }

    return '';
};



//////////////
export const tenant = () => JSON.parse( localStorage.getItem('tenant'));
export const appStorageKey = (key) => {
    const appName = process.env.REACT_APP_NAME || 'finance-web';
    return `${appName}:${key}`;
}
export const languagesCode =  ()=> tenant().languages?.map((language) =>  language.langCode )
export const generlSettings = () => tenant()?.setting?.generalSettings;
export const  AppSettings =  () => tenant()?.setting?.appSetting;
export const user = () => JSON.parse( localStorage?.getItem('user'));

// Tenant Companies
export const tenantCompaniesByLang = (lang) => {
    return tenant()?.companies?.map( company => { 
            return {
                companyId:company._id ,
                companyName: arrayNameByLang(company.name,lang)
            }
        });
}
export const BranchesByCompanyId = (companyId) => tenant()?.companies?.filter( (company) => company._id === companyId)[0]?.branches;

export const getCompanyById = (id) => tenant()?.companies?.filter(company => company._id === id)[0]


// Language Text Object
export const arrayNameByLang = (arrayName,lang) => {
    return  arrayName && arrayName.filter( name => name.lang === lang)[0] ;
}
export const langObjType = () =>{
    return languagesCode().reduce((k,v)=> ({...k,[v]:''}),{})
}
export const objLangTextHandler = (textObj) =>{
    let textHandler = [];
    for( const [key,value] of Object.entries(textObj)){
        textHandler.push( {
            text : value ,
            lang : key
        })
    }
    return textHandler
}

// General Settings
export const getGeneralSettings =  (settingName) => generlSettings()?.filter(setting => setting.name === settingName)[0]?.value 
export const defaultLang = getGeneralSettings('DEFAULT_LANG') || 'en';

// Invoice App Settings
export const invoiceAppSettings = () => AppSettings()?.filter(setting => setting?.app?.name === 'Invoices')[0];
export const getValueInvoiceAppSettings = (optionName) => invoiceAppSettings()?.setting?.filter(item => item.name === optionName)[0]?.value

export const printableDiv = (divPrintRef,lang='ar') => {
    if (!divPrintRef?.current) return;
    const content = divPrintRef.current.outerHTML || divPrintRef.current.innerHTML;
    const dir = lang === 'ar' ? 'rtl' : 'ltr';
    const printWindow = window.open('', '_blank');

    const printOverrideCss = `
      <style>
        @media print {
          * {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            color-adjust: exact !important;
          }
          body, body * {
            visibility: visible !important;
          }
          #codex-print-root {
            position: static !important;
            left: auto !important;
            top: auto !important;
            width: 100% !important;
            padding: 0 !important;
            margin: 0 !important;
            background: transparent !important;
          }
        }
        body {
          margin: 0;
          padding: 8px;
          background: #f8fafc;
        }
      </style>
    `;

    printWindow.document.write(
      '<html><head>' +
      document.head.innerHTML +
      printOverrideCss +
      '</head><body dir="' +
      dir +
      '"><div id="codex-print-root">' +
      content +
      '</div></body></html>'
    );
    setTimeout(() => {
        printWindow.print();
        printWindow.close();
        printWindow.document.close();
    }, 1000);
    // printWindow.onafterprint = function() {    
    // };
}

export const getDateNow = () => {
    var d = new Date();
    var local = d.getTime();
    var offset = d.getTimezoneOffset() * (60 * 1000);
    var utc = new Date(local + offset);
    var riyadh = new Date(utc.getTime() + (3 * 60 * 60 * 1000));
    return riyadh;
}
